import { AsyncPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { CacheService } from '@se/platform';
import { map } from 'rxjs';

export interface VersionJson {
    ESTENSA_VERSION: string;
    ESTENSA_BUILD: string;
}

@Component({
    selector: 'se-about-box',
    templateUrl: './about-box.component.html',
    styleUrls: ['./about-box.component.scss'],
    standalone: true,
    imports: [AsyncPipe, MatButtonModule, MatCardModule, MatDialogModule],
})
export class AboutBoxComponent {
    private readonly cache = inject(CacheService);
    private readonly http = inject(HttpClient);

    version$ = this.cache.get(
        'version.json',
        this.http.get<VersionJson>('version.json').pipe(map((response) => response.ESTENSA_BUILD)),
    );
}
